import prepareDetails from "@helpers/prepareDetails";
import axios from "@common/api/desktop/axios";

export const fetchOperatorProfiles = async (operatorId) => {
  const profiles = await axios.get(`SettingsProfile/profiles/${operatorId}`);

  return profiles.data.map((profile) => {
    return { key: profile.id, value: profile.id, text: profile.name };
  });
};

export const fetchProfile = async (operatorId, profileId = -1) => {
  const profile = await axios.get(
    `/SettingsProfile/profile/${operatorId},${profileId}`,
  );
  return profile.data;
};

export const fetchProfileBySite = async (operatorId, profileId = -1) => {
  const profile = await axios.get(
    `/SettingsProfile/profile/bysite/${operatorId},${profileId}`,
  );
  return profile.data;
};

export const fetchProfileOptions = async (operatorId) => {
  const profile = await axios.get(`/SettingsProfile/profiles/${operatorId}`);
  return profile.data;
};

export const changeProfile = async (operatorId, siteId, profileId) => {
  const profile = await axios.put(
    `/SettingsProfile/profile/change/${operatorId},${siteId},${profileId}`,
  );
  return profile.data;
};

export const newProfile = async (operatorId, profileId) => {
  const response = await axios.get(
    `/SettingsProfile/new/${operatorId},${profileId}`,
  );
  return response.data;
};

export const deleteProfile = async (operatorId, profileId) => {
  const response = await axios.delete(
    `/SettingsProfile/profile/delete/${operatorId},${profileId}`,
  );
  return response.data;
};

export const getSite = async (siteId) => {
  const response = await axios.get(`Organisation/site/${siteId}`);
  return response.data;
};

export const getSubCompany = async (subcompanyId) => {
  const response = await axios.get(`Organisation/region/${subcompanyId}`);
  return response.data;
};

export const getCompany = async (companyId) => {
  const response = await axios.get(`Organisation/company/${companyId}`);
  return response.data;
};

export const getNewCompany = async (operatorId) => {
  const response = await axios.get(`/Organisation/newcompany/${operatorId}`);
  return response.data;
};

export const getNewRegion = async (operatorId, companyId) => {
  const response = await axios.get(
    `/Organisation/newregion/${operatorId},${companyId}`,
  );
  return response.data;
};

export const getNewSite = async (operatorId, companyId, regionId) => {
  const response = await axios.get(
    `/Organisation/newsite/${operatorId},${companyId},${regionId}`,
  );
  return response.data;
};

export const fetchOpeningHoursProfiles = async (operatorId) => {
  const profiles = await axios.get(`OpeningHours/profiles/${operatorId}`);

  return profiles.data.map((profile) => {
    return { key: profile.id, value: profile.id, text: profile.name };
  });
};

export const fetchOpeningHoursProfile = async (operatorId, profileId) => {
  const response = await axios.get(
    `OpeningHours/profile/${operatorId},${profileId}`,
  );
  return response.data;
};

export const updateOpeningHours = async (OperatorId, id, name, details) => {
  const response = await axios.put(`/OpeningHours/update`, {
    id,
    OperatorId,
    name,
    details,
  });
  return response.data;
};

export const getOpeningHoursNew = async (operatorId) => {
  const response = await axios.get(`/OpeningHours/new/${operatorId}`);
  return response.data;
};

export const updateSettingsProfile = async (
  operatorId,
  profileId,
  baseProfileId,
  details,
) => {
  const payload = {
    id: profileId,
    operatorId,
    profileId: baseProfileId,
    details: prepareDetails(details),
  };
  const response = await axios.put(`/SettingsProfile/update/`, payload);
  return response.data;
};

export const updateSite = async (
  OperatorId,
  CompanyId,
  RegionId,
  siteId,
  details,
) => {
  const payload = {
    id: siteId,
    OperatorId,
    CompanyId,
    RegionId,
    details: prepareDetails(details),
  };
  const response = await axios.put(`/organisation/updatesite/`, payload);
  return response.data;
};

export const updateRegion = async (
  OperatorId,
  CompanyId,
  regionId,
  details,
) => {
  const payload = {
    id: regionId,
    OperatorId,
    CompanyId,
    details: prepareDetails(details),
  };
  const response = await axios.put(`/organisation/updateregion/`, payload);
  return response.data;
};

export const updateCompany = async (OperatorId, companyId, details) => {
  const payload = {
    id: companyId,
    OperatorId,
    details: prepareDetails(details),
  };
  const response = await axios.put(`/organisation/updatecompany/`, payload);
  return response.data;
};

export const updateOperator = async (OperatorId, details) => {
  const payload = { id: OperatorId, details: prepareDetails(details) };
  const response = await axios.put(`/organisation/updateoperator/`, payload);
  return response.data;
};

export const getCalender = async (operatorId, year) => {
  const response = await axios.get(
    `/Calendar/GetCalendar/${operatorId},${year}`,
  );
  return response.data;
};

export const getOperatorOptions = async (operatorId) => {
  const response = await axios.get(`/organisation/operator/${operatorId}`);
  const data = [
    ...response.data.map((x) => {
      return { ...x, type: "options" };
    }),
  ];

  return data;
};

export const getNewOperator = async () => {
  const response = await axios.get(`/organisation/newoperator`);
  return response.data;
};
